import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { removeLocalData } from "../../helpers/storage-helper";
import { authActions } from "../../store/auth";
import { templateAction } from "../../store/template-store";
import Loader from "../UI/loader";
import {
  AiFillCaretDown,
  AiOutlineHome,
  AiOutlineSetting,
  AiOutlineUser,
  AiOutlineCarryOut,
  AiOutlineGift,
} from "react-icons/ai";
import { FiUsers } from "react-icons/fi";

import "./header.css";
import { ImProfile } from "react-icons/im";
import { HiOutlineLogout } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import { BsCameraVideo } from "react-icons/bs";
import useOnclickOutside from "react-cool-onclickoutside";
// import { FcBusiness } from "react-icons/fc";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { IoMagnetOutline } from "react-icons/io5";
import { FaUikit } from "react-icons/fa";

const Header = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loader = useSelector((state) => state.auth.loader);
  const onLogout = () => {
    removeLocalData("vidamaze_user");
    removeLocalData("vidamaze_ezdata");
    dispatch(authActions.logout());
    dispatch(authActions.resetState());
    dispatch(templateAction.resetState());
    history.push("/login");
  };

  const [showActionPopup, setShowActionPopup] = useState(false);
  const [showBonusPopup,setShowBonusPopup] = useState(false);
  const access = useSelector((state) => state.auth.access);

  const meta_data = useSelector(state => state.auth.product.meta_data)

  const favlogo = meta_data && JSON.parse(meta_data).subdomainFavicon ? JSON.parse(meta_data).subdomainFavicon : '';
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : '';
  // console.log(access);

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)
  console.log(subdomain_name);



  const refsubMenu = useOnclickOutside(() => {
    setShowActionPopup(false);
  });

  const user_roles = useSelector((state) => state.auth.roles);
  const first_name = useSelector((state) => state.auth.first_name);

  useEffect(() => {
    
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    // link.href = favlogo;
    if( favlogo !== '' ){
      link.href = favlogo;
    }

   
    return () => {};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favlogo]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--main-color', '#333c59'); //#908fa1 text color
    root.style.setProperty('--btn-bg-color', '#ff3987'); //#904ece button background color
    root.style.setProperty('--btn-bg-hover-color', '#ff0266'); // #904ece, #d85993 Button background color on hover

    if(subdomain_name === 'vidwise'){
      root.style.setProperty('--main-color', '#9C6260'); // text color
      root.style.setProperty('--btn-bg-color', '#1f0403'); // button background color
      root.style.setProperty('--btn-bg-hover-color', '#523836'); //Button background color on hover
    }

    if(subdomain_name === 'nicheflick'){
      root.style.setProperty('--main-color', '#0F1225'); // text color
      root.style.setProperty('--btn-bg-color', '#3C9DF3'); // button background color
      root.style.setProperty('--btn-bg-hover-color', '#0F1225'); //Button background color on hover
    }

  }, [subdomain_name]);

  return (
    <>
      {
        subdomain_name === 'vidwise' && (
          <style>
            {`
            body{ background: #FFE6DC  !important;  }
            .mid_wrap {  background: #FFE6DC  !important;  }
            
            .nav-tabs .nav-link.active {
              border: #1f0403 1px solid!important;
              background: #1f0403!important;
            }
            .progress-bar {
              background: #1f0403b5 !important;
              background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent) !important;
              background-size: 1rem 1rem !important;
            }
            .progress {
              background: #FFE6DC !important;
            }

            #header .navbar-expand-md .navbar-nav > li > a {
              font-size: 20px;
            }
            
            `}
            
          </style>
        )
      }


      <header id="header">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <NavLink className="navbar-brand" to="/">

              {
                logo && <img
                  src={logo}
                  className="img-fluid max-250"
                  alt="img"
                />
              }
              
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="fa fa-bars"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav" style={{paddingLeft: '100px'}}>
                


                {
                  ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/dashboard"
                    >
                      <i>
                        <AiOutlineHome size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Dashboard</span>
                    </NavLink>
                  </li>
                  )
                }

                {
                  ( ( subdomain_name === 'vidwise' ) || ( subdomain_name === 'nicheflick' ) ) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/dashboard"
                    >
                      <i>
                        <AiOutlineHome size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Video Dashboard</span>
                    </NavLink>
                  </li>
                  )
                }
                
                {
                  ( subdomain_name === 'vidwise' ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link h6 mb-0"
                      aria-current="page"
                      href="https://vidwiseai.engageleads.net/directory/"
                    >
                      <i>
                        <AiOutlineHome size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Campaigns</span>
                    </a>
                  </li>
                  )
                }
                
                {
                  ( subdomain_name === 'nicheflick' ) && (
                  <li className="nav-item">
                    <a
                      className="nav-link h6 mb-0"
                      aria-current="page"
                      href="https://nicheflicks.engageleads.net/directory/"
                    >
                      <i>
                        <AiOutlineHome size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Campaigns</span>
                    </a>
                  </li>
                  )
                }

                
                {
                  ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                  
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/settings"
                    >
                      <i>
                        <AiOutlineSetting size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Settings</span>
                    </NavLink>
                  </li>
                  )
                }
              
                {( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && ( access.includes("5") || access.includes("4A") || access.includes("1a") ||access.includes("8A")) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/dfy"
                    >
                      <i>
                        <AiOutlineCarryOut size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Agency</span>
                    </NavLink>
                  </li>
                )}
                { ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (access.includes("5") || access.includes("2A")  || access.includes("7A") || access.includes("1a") || access.includes("8A")) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/leadcraft"
                    >
                      <i>
                        <IoMagnetOutline size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>LeadCraft AI</span>
                    </NavLink>
                  </li>
                )}
                {( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (access.includes("5") || access.includes("6A") || access.includes("1a") ||access.includes("8A") ) && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/masterclass"
                  >
                    <i>
                      <AiOutlineHome size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>MasterClass</span>
                  </NavLink>
                </li>
                )}
                {( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) &&  (access.includes("5")  || access.includes("1b-")  ) && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/vidAgencykitai"
                  >
                    <i>
                      <FaUikit size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>VidAgencyKit AI</span>
                  </NavLink>
                </li>
                )}
                {(access.includes("5") && false ) && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/bump"
                  >
                    <i>
                      <MdOutlineAlternateEmail size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Add-on</span>
                  </NavLink>
                </li>
                )}

                {(  ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) &&  !access.includes("5") && !access.includes("9A")) && (
                  <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/tutorials"
                  >
                    <i>
                      <BsCameraVideo size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Tutorials</span>
                  </NavLink>
                </li>
                )}
              
                {( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (access.includes("5") ) && (
                  <li className="nav-item dropdown">
                    
                    <a
                      data-bs-toggle="dropdown"
                      href="#collapseExampleBonus"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseExampleBonus"
                      onClick={(e) => setShowBonusPopup(!showBonusPopup)}
                      className="nav-link mb-0 h6 dropdown-toggle"
                    >
                      <AiOutlineGift size={16} />
                      <span style={{ verticalAlign: "middle" }}>
                        Bonuses
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                        <li>
                          <a href="https://engageleads.lpages.co/vidcraftai-bonuses-download/" target="_blank" rel="noreferrer" className={"dropdown-item"}>
                            <ImProfile size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Promised Bonuses
                            </span>
                          </a>
                        </li>
                        
                    </ul>
                    
                  </li>
                )}

                {(user_roles.role_id === 3 || user_roles.role_id === 2) && access.includes("5") && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      to="/users"
                      aria-disabled="true"
                    >
                      <i>
                        <FiUsers size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Users</span>
                    </NavLink>
                  </li>
                )}
              </ul>

              <div className="last_t_r ms-auto">
                <NavLink
                  data-bs-toggle="collapse"
                  to="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  onClick={(e) => setShowActionPopup(!showActionPopup)}
                  className="text-secondary mb-0 h5"
                >
                  {/* <img
                    src={`${process.env.PUBLIC_URL}/assets/images/userImage.jpg`}
                    alt="img"
                  /> */}
                  <AiOutlineUser size={16} />
                  <span className="mx-1" style={{ verticalAlign: "middle" }}>
                    {first_name}
                  </span>
                  <AiFillCaretDown />
                </NavLink>
                <div
                  className={`collapse profile_popup ${
                    showActionPopup && "show"
                  }`}
                  id="collapseExample"
                  ref={refsubMenu}
                >
                  <div className="">
                    <ul>
                      { ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (!access.includes("91")) && (
                        <li>
                          <NavLink to="/profile">
                            <ImProfile size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Profile
                            </span>
                          </NavLink>
                        </li>
                      )}
                      { (access.includes("5") || access.includes("9S")) && (
                        <li>
                          <NavLink to="/alltemplates">
                            <ImProfile size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              All Templates
                            </span>
                          </NavLink>
                        </li>
                      )}
                      {(access.includes("5") || access.includes("9S")) && (
                        <li>
                          <NavLink to="/uploadAssets">
                            <ImProfile size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Upload Assets
                            </span>
                          </NavLink>
                        </li>
                      )}
                      
                      {( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                      <li>
                          <NavLink to="/tutorials">
                            <BsCameraVideo size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Tutorials
                            </span>
                          </NavLink>
                        </li>
                      )}
                        <li>
                          <NavLink to="/support">
                            <BiSupport size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Support
                            </span>
                          </NavLink>
                        </li>
                      <li>
                        <a href="#0" onClick={onLogout}>
                          <HiOutlineLogout size={16} />
                          <span
                            className="mx-2"
                            style={{ verticalAlign: "middle" }}
                          >
                            Logout
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      {/* <Loader /> */}
      {loader && <Loader />}
    </>
  );
};

export default Header;
